import { useStore } from '@tanstack/react-store';
import { Store } from '@tanstack/store';

export type PopupState = {
  open: boolean;
  type: 'paywall' | 'need-login';
};

export type TPopupTypes = 'paywall' | 'need-login';

export const popupStore = new Store<PopupState>({
  open: false,
  type: 'paywall',
});

// Actions kept outside for stable references
export const popupActions = {
  // Open modal with optional reason
  openModal: (type: TPopupTypes) => popupStore.setState((prev) => ({ ...prev, open: true, type })),
  // Close modal and clear reason
  close: () => popupStore.setState((prev) => ({ ...prev, open: false })),
};

export function usePopup() {
  const state = useStore(popupStore, (s) => s);

  return {
    ...state,
    ...popupActions,
  };
}
